var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipKosher({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37 10.72L9.06 9.52H7.68L8.37 10.72Z",
    fill: "#00AEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17L12.72 15.76H11.28L12 17Z",
    fill: "#00AEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68 14.48H9.06L8.37 13.28L7.68 14.48Z",
    fill: "#00AEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.54 9.52L9.11 12L10.54 14.48H13.46L14.89 12L13.46 9.52H10.54Z",
    fill: "#00AEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7L11.28 8.24H12.72L12 7Z",
    fill: "#00AEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.94 14.48H16.32L15.63 13.28L14.94 14.48Z",
    fill: "#00AEFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM17.98 14.8C18.09 15 18.09 15.24 17.98 15.44C17.87 15.64 17.65 15.76 17.43 15.76H14.2L12.56 18.6C12.45 18.8 12.23 18.92 12.01 18.92C11.79 18.92 11.57 18.8 11.46 18.6L9.82 15.76H6.59C6.36 15.76 6.15 15.64 6.04 15.44C5.93 15.24 5.93 15 6.04 14.8L7.66 12L6.04 9.2C5.93 9 5.93 8.76 6.04 8.56C6.15 8.36 6.37 8.24 6.59 8.24H9.82L11.46 5.4C11.57 5.2 11.79 5.08 12.01 5.08C12.23 5.08 12.45 5.2 12.56 5.4L14.2 8.24H17.43C17.66 8.24 17.87 8.36 17.98 8.56C18.09 8.76 18.09 9 17.98 9.2L16.36 12L17.98 14.8Z",
    fill: "#00AEFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.63 10.72L16.32 9.52H14.94L15.63 10.72Z",
    fill: "#00AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipKosher);
export default __webpack_public_path__ + "static/media/ic-chip-kosher.e61a78e28d6acbb56f5445a924ebfc12.svg";
export { ForwardRef as ReactComponent };